<template>
  <ValidationProvider
    :name="$attrs.label || $attrs.name"
    :rules="rules"
    v-slot="{ errors }"
  >
    <v-text-field
      :id="id"
      v-model="location.name"
      v-bind="$attrs"
      :error-messages="errors"
      :clearable="$attrs.clearable === undefined ? true : $attrs.clearable"
      @click:clear="clear"
    >
      <template v-slot:append>
        <slot></slot>
      </template>
    </v-text-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { setAddressMixin } from "@/mixins/setAddress";

export default {
  components: {
    ValidationProvider
  },
  mixins: [setAddressMixin],
  props: {
    id: {
      type: String,
      default: "location-field"
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object
    },
    noRestrictions: {
      type: Boolean
    }
  },
  data: () => ({
    location: null
  }),
  watch: {
    value(newVal) {
      this.location = newVal;
    }
  },
  created() {
    this.setLocation();
    if (this.value) {
      this.location = this.value;
    }
  },
  mounted() {
    // PATCH: google not loaded properly
    setTimeout(() => {
      this.initAutocomplete();
    });
  },
  methods: {
    setLocation() {
      // TODO: use model instead
      this.location = {
        name: null,
        street1: null,
        street2: null,
        street3: null,
        city: null,
        state: null,
        postcode: null,
        country: null,
        coordinates: []
      };
    },
    clear() {
      this.setLocation();
      this.$emit("input", this.location);
      this.$emit("change", this.location);
    },
    initAutocomplete() {
      let input = document.getElementById(this.id);
      let autocomplete = new window.google.maps.places.Autocomplete(input);

      //  Restrict the location search with UK based only
      if (!this.noRestrictions) {
        autocomplete.setComponentRestrictions({ country: ["gb"] });
      }
      autocomplete.setFields([
        "address_components",
        "geometry",
        "formatted_address"
      ]);
      autocomplete.addListener("place_changed", () => {
        var place = autocomplete.getPlace();
        if (!place.geometry) {
          window.alert("No details available for input: '" + place.name + "'");
          return;
        }
        this.setAddress(place);
        this.$emit("input", this.location);
        this.$emit("change", this.location);
      });
    }
  }
};
</script>

<style>
.pac-container {
  width: 30% !important;
}
</style>
